









import { FillInBlankContent } from '@/resource/question/question.type';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getSubjectiveOrder } from '@/utils/subjective-util';

@Component({})
export default class SubjectiveFillBlank extends Vue {
  @Prop({ required: true })
  content!: FillInBlankContent;

  get orderType() {
    getSubjectiveOrder;
    return this.content.config.orderType;
  }

  get lists() {
    return this.content.content.map(list => {
      const textArray = list.split('##').map((text, index) => {
        const isEvenIndex = index % 2 !== 0;

        if (isEvenIndex) {
          return this.addClassForAnswer(text);
        } else {
          return text;
        }
      });

      return textArray.join('');
    });
  }

  addClassForAnswer(text: string) {
    return `<p class="text-gray-400 inline underline italic">${text}</p>`;
  }

  getOrder(index: number) {
    if (this.orderType) {
      return getSubjectiveOrder(this.orderType, index);
    }
  }
}
